"use strict";

import { Grid } from "@mui/material";
import React, { useContext, useEffect } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useNavigate } from "react-router-dom";
import ViewListIcon from "@mui/icons-material/ViewList";
import GroupIcon from "@mui/icons-material/Group";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import classes from "../Assets/Styles/Global.module.css";
import { Store } from "../Store";

function LandingAdminPage() {
  const navigate = useNavigate();
  const { dispatch: ctxDispatch } = useContext(Store);

  // useEffect(() => {
  //   const getAccessToken = async () => {
  //     await axios
  //       .get(GET_ACESS_TOKEN)
  //       .then((response) => {
  //         ctxDispatch({
  //           type: "SAVE_ACESS_TOKEN",
  //           payload: response.data.access_token,
  //         });
  //         localStorage.setItem(
  //           "accessToken",
  //           JSON.stringify(response.data.access_token)
  //         );
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //         // toast.error("server is down");
  //       });
  //   };

  //   getAccessToken();
  // }, []);

  useEffect(() => {
    ctxDispatch({ type: "PROJECT_FILE_CLEAR" });
    // localStorage.removeItem("projectFile");
  }, [ctxDispatch]);

  return (
    <Grid item container justifyContent="center" marginBottom={49.7}>
      <Grid
        item
        container
        xs={9}
        maxWidth="980px"
        marginTop={8}
        direction="column"
        gap={4}
        className={classes["adminMenuPanel"]}
      >
        <Grid
          item
          container
          alignItems="center"
          direction="row"
          sx={{ cursor: "pointer" }}
          className={classes["adminMenuRow"]}
          onClick={() => {
            navigate("/createproject");
          }}
        >
          <Grid
            item
            container
            width="100px"
            height="100px"
            alignContent="center"
            justifyContent="center"
            marginRight={2}
            borderRadius="var(--radius-md)"
            className={`${classes["bigIcons"]} ${classes["adminMenuIcon"]}`}
          >
            <AddCircleIcon fontSize="large" />
          </Grid>
          <Grid item className={`${classes["labels"]} ${classes["adminMenuLabel"]}`}>
            New Video Project
          </Grid>
        </Grid>
        <Grid
          item
          container
          alignItems="center"
          direction="row"
          sx={{ cursor: "pointer" }}
          className={classes["adminMenuRow"]}
          onClick={() => {
            navigate("/file-upload");
          }}
        >
          <Grid
            item
            container
            width="100px"
            height="100px"
            alignContent="center"
            justifyContent="center"
            marginRight={2}
            borderRadius="var(--radius-md)"
            className={`${classes["bigIcons"]} ${classes["adminMenuIcon"]}`}
          >
            <UploadFileIcon fontSize="large" />
          </Grid>
          <Grid item className={`${classes["labels"]} ${classes["adminMenuLabel"]}`}>
            Upload File
          </Grid>
        </Grid>
        <Grid
          item
          container
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
            gap: 3,
          }}
        >
          <Grid
            item
            container
            alignItems="center"
            direction="row"
            sx={{ cursor: "pointer" }}
            className={classes["adminMenuRow"]}
            onClick={() => {
              navigate("/admin/videoprojects");
            }}
          >
            <Grid
              item
              container
              width="100px"
              height="100px"
              alignContent="center"
              justifyContent="center"
              marginRight={2}
              borderRadius="var(--radius-md)"
              className={`${classes["bigIcons"]} ${classes["adminMenuIcon"]}`}
            >
              <ViewListIcon fontSize="large" />
            </Grid>
            <Grid item className={`${classes["labels"]} ${classes["adminMenuLabel"]}`}>
              Video Projects
            </Grid>
          </Grid>
          <Grid
            item
            container
            alignItems="center"
            direction="row"
            sx={{ cursor: "pointer" }}
            className={classes["adminMenuRow"]}
            onClick={() => {
              navigate("/admin/audioprojects");
            }}
          >
            <Grid
              item
              container
              width="100px"
              height="100px"
              alignContent="center"
              justifyContent="center"
              marginRight={2}
              borderRadius="var(--radius-md)"
              className={`${classes["bigIcons"]} ${classes["adminMenuIcon"]}`}
            >
              <ViewListIcon fontSize="large" />
            </Grid>
            <Grid item className={`${classes["labels"]} ${classes["adminMenuLabel"]}`}>
              Audio Projects
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          container
          alignItems="center"
          direction="row"
          sx={{ cursor: "pointer" }}
          className={classes["adminMenuRow"]}
          onClick={() => {
            navigate("/admin/users");
          }}
        >
          <Grid
            item
            container
            width="100px"
            height="100px"
            alignContent="center"
            justifyContent="center"
            marginRight={2}
            borderRadius="var(--radius-md)"
            className={`${classes["bigIcons"]} ${classes["adminMenuIcon"]}`}
          >
            <PeopleAltIcon fontSize="large" />
          </Grid>
          <Grid item className={`${classes["labels"]} ${classes["adminMenuLabel"]}`}>
            Users
          </Grid>
        </Grid>
        <Grid
          item
          container
          alignItems="center"
          direction="row"
          sx={{ cursor: "pointer" }}
          className={classes["adminMenuRow"]}
          onClick={() => {
            navigate("/admin/teams");
          }}
        >
          <Grid
            item
            container
            width="100px"
            height="100px"
            alignContent="center"
            justifyContent="center"
            marginRight={2}
            borderRadius="var(--radius-md)"
            className={`${classes["bigIcons"]} ${classes["adminMenuIcon"]}`}
          >
            <GroupIcon fontSize="large" />
          </Grid>
          <Grid item className={`${classes["labels"]} ${classes["adminMenuLabel"]}`}>
            Teams
          </Grid>
        </Grid>
        {/* <Grid item container fontSize="var(--font-size-header)" marginBottom={2}>
          Templates
        </Grid>
        <Grid item container direction="column">
          <Grid item container fontSize="var(--font-size-header)">
            Audio
          </Grid>
          <Grid item container direction="row">
            <Grid
              item
              container
              width="100px"
              height="100px"
              // bgcolor="#5570dc"
              bgcolor="grey"
              marginRight={3}
              borderRadius="var(--radius-md)"
              sx={{ cursor: "pointer" }}
              // onClick={() => {
              //   navigate("/work/transcriber");
              // }}
              // marginBottom={3}
            >
              <AddCircleIcon fontSize="large" />
              <Grid item>Transcription</Grid>
            </Grid>
            <Grid
              item
              container
              width="100px"
              height="100px"
              // bgcolor="#5570dc"
              bgcolor="grey"
              marginRight={3}
              borderRadius="var(--radius-md)"
              sx={{ cursor: "pointer" }}
              // onClick={() => {
              //   navigate("/work/translator");
              // }}
              // marginBottom={3}
            >
              <AddCircleIcon fontSize="large" />
              <Grid item>Translation</Grid>
            </Grid>
            <Grid
              item
              container
              width="100px"
              height="100px"
              // bgcolor="#5570dc"
              bgcolor="grey"
              marginRight={3}
              borderRadius="var(--radius-md)"
              // onClick={() => {
              //   navigate("/work/qualityassurance");
              // }}
              // marginBottom={3}
            >
              <AddCircleIcon fontSize="large" />
              <Grid item>New Review</Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item container direction="column">
          <Grid item container fontSize="var(--font-size-header)">
            Video
          </Grid>
          <Grid item container direction="row">
            <Grid
              item
              container
              width="100px"
              height="100px"
              bgcolor="grey"
              marginRight={3}
              borderRadius="var(--radius-md)"
              // direction="column"
              // justifyContent="space-between"
              // marginBottom={3}
            >
              <AddCircleIcon fontSize="large" />
              <Grid item>New Skits</Grid>
            </Grid>
            <Grid
              item
              container
              width="100px"
              height="100px"
              bgcolor="grey"
              marginRight={3}
              borderRadius="var(--radius-md)"
              // marginBottom={3}
            >
              <AddCircleIcon fontSize="large" />
              <Grid item>New Show</Grid>
            </Grid>
            <Grid
              item
              container
              width="100px"
              height="100px"
              bgcolor="grey"
              marginRight={3}
              borderRadius="var(--radius-md)"
              // marginBottom={3}
            >
              <AddCircleIcon fontSize="large" />
              <Grid item>New Episode</Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item container direction="column">
          <Grid item container fontSize="var(--font-size-header)">
            Basic
          </Grid>
          <Grid item container direction="row">
            <Grid
              item
              container
              width="100px"
              height="100px"
              bgcolor="grey"
              marginRight={3}
              borderRadius="var(--radius-md)"
              // marginBottom={3}
            >
              <AddCircleIcon fontSize="large" />
              <Grid item>New Character</Grid>
            </Grid>
            <Grid
              item
              container
              width="100px"
              height="100px"
              bgcolor="grey"
              marginRight={3}
              borderRadius="var(--radius-md)"
              // marginBottom={3}
            >
              <AddCircleIcon fontSize="large" />
              <Grid item>New Script</Grid>
            </Grid>
          </Grid>
        </Grid> */}
      </Grid>
    </Grid>
  );
}

export default LandingAdminPage;
